const Index = () => import('Views/thematicSelectedCharacteristicHotspot/index');

export default[
  { path: '/thematic-selected-characteristic-hotspot', component: Index },
];



// WEBPACK FOOTER //
// ./src/router/thematicSelectedCharacteristicHotspot.js